import _ from 'lodash';
import { AST } from '../ast';
import { Assert } from '../utils';

export const mapExprFR = (
  expr: AST.ExprFR,
  cb: (x: AST.ExprFR) => AST.ExprFR
): AST.ExprFR => {
  const { t } = expr;

  let mapped: AST.ExprFR;

  switch (t) {
    case 'scalar':
    case 'attr':
      mapped = expr;
      break;
    case 'function-call':
      mapped = { ...expr, args: expr.args.map((arg) => mapExprFR(arg, cb)) };
      break;
    case 'make-array':
      mapped = {
        ...expr,
        elements: expr.elements.map((elem) => mapExprFR(elem, cb)),
      };
      break;
    case 'cast':
      mapped = {
        ...expr,
        expr: mapExprFR(expr.expr, cb),
      };
      break;
    case 'make-struct':
      mapped = {
        ...expr,
        fields: _.mapValues(expr.fields, (field) => mapExprFR(field, cb)),
      };
      break;
    case 'get-field':
      mapped = {
        ...expr,
        expr: mapExprFR(expr.expr, cb),
      };
      break;
    case 'invariants':
      mapped = {
        ...expr,
        expr: mapExprFR(expr.expr, cb),
        invariants: _.mapValues(expr.invariants, (ex) => mapExprFR(ex, cb)),
      };
      break;
    case 'window':
      mapped = {
        ...expr,
        args: expr.args.map((arg) => mapExprFR(arg, cb)),
        over: {
          partitionBy: expr.over.partitionBy.map((arg) => mapExprFR(arg, cb)),
          orderBy: expr.over.orderBy.map(({ expr, direction }) => ({
            direction,
            expr: mapExprFR(expr, cb),
          })),
        },
      };
      break;
    case 'case':
      mapped = {
        t: 'case',
        cases: expr.cases.map(({ when, then }) => ({
          when: mapExprFR(when, cb),
          then: mapExprFR(then, cb),
        })),
        else: expr.else !== undefined ? mapExprFR(expr.else, cb) : undefined,
      };
      break;
    case 'categorize':
      mapped = {
        t: 'categorize',
        logic: expr.logic.map((x) => ({ ...x, expr: mapExprFR(x.expr, cb) })),
      };
      break;
    case 'expr-var':
      mapped = {
        ...expr,
        default: expr.default ? mapExprFR(expr.default, cb) : null,
      };
      break;
    case 'macro-expr-case':
      mapped = {
        t: 'macro-expr-case',
        cases: expr.cases.map(({ when, then }) => ({
          when: mapExprFR(when, cb),
          then: mapExprFR(then, cb),
        })),
        else: mapExprFR(expr.else, cb),
      };
      break;
    case 'macro-apply-vars-to-expr':
      mapped = {
        ...expr,
        vars: {
          exprs: _.mapValues(expr.vars.exprs, (x) => mapExprFR(x, cb)),
        },
        sources: {
          from: mapExprFR(expr.sources.from, cb),
        },
      };
      break;
    default:
      return Assert.unreachable(t);
  }

  return cb(mapped);
};
